import React, { useState } from 'react';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import AttachmentTools from './AttachmentTools';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AttachmentToolsMenu = ({
  allowManage,
  attachment,
  category,
  code,
  exceedsDownloadSize,
  isDownloading,
  upward,
}) => {
  const [open, setOpen] = useState(false);
  const {
    canDelete, canDownload, canIngest, canUpdate, isLoading,
  } = Selectors.useAttachmentToolsMenu({ category, code, attachment });
  const showDeleteDialog = Events.useShowDeleteDatasetAttachment(category, { code });
  const supportsDownload = canDownload && !exceedsDownloadSize;
  const supportsUpdate = allowManage && canUpdate;

  if (!canDelete && !supportsDownload && !canIngest && !supportsUpdate) {
    return null;
  }

  return (
    <StandardToolsMenu
      allowDelete={canDelete}
      className="dataset-attachment-tools"
      upward={upward}
      onChange={setOpen}
      onDelete={() => showDeleteDialog({ attachment })}
      open={open}
    >
      {open && (
        <AttachmentTools
          attachment={attachment}
          canDownload={supportsDownload}
          canIngest={canIngest}
          canManage={canUpdate}
          canUpdate={supportsUpdate}
          category={category}
          code={code}
          isDownloading={isDownloading}
          isLoading={isLoading}
        />
      )}
    </StandardToolsMenu>
  );
};

export default AttachmentToolsMenu;
